import type { FIELD__list_base_generic } from '../../_primitives/list/FIELD__list_base_generic';
import { FIELD__base } from '../FIELD__base';
import { ENUM__field_connectable_type } from './ENUM__field_connectable_type';

export function FN_FIELD__fields_types_are_compatible(field_a: FIELD__base, field_b: FIELD__base) {
  // Use your existing ENUM to check if it's a list without needing the class reference
  const is_list_a = field_a.field_connectable__type() === ENUM__field_connectable_type.LIST;
  const is_list_b = field_b.field_connectable__type() === ENUM__field_connectable_type.LIST;

  const list_a = field_a as unknown as FIELD__list_base_generic<any>;
  const list_b = field_b as unknown as FIELD__list_base_generic<any>;

  let out: boolean;

  if (is_list_a && is_list_b) {
    out = list_a.field_connectable__type_item() == list_b.field_connectable__type_item();
  } else if (is_list_a) {
    out = list_a.field_connectable__type_item() == field_b.field_connectable__type();
  } else if (is_list_b) {
    out = field_a.field_connectable__type() == list_b.field_connectable__type_item();
  } else {
    out = field_a.field_connectable__type() == field_b.field_connectable__type();
  }

  return out;
}
